import { render, staticRenderFns } from "./settlemanetPrint.vue?vue&type=template&id=2fff6ea6&scoped=true&"
import script from "./settlemanetPrint.vue?vue&type=script&lang=js&"
export * from "./settlemanetPrint.vue?vue&type=script&lang=js&"
import style0 from "./settlemanetPrint.vue?vue&type=style&index=0&id=2fff6ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff6ea6",
  null
  
)

export default component.exports